export const rescueFailingProject = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare',
  url: 'https://boldare.com/',
  description:
    'Digital product design company. Web development, Mobile Development, No Code Development, Custom Application Development, Product Design, UI/UX Design, Design Systems, Digital Prototyping.',
};
